<div class="container header web">
  <div>plaats</div>
  <div>datum</div>
  <div>tijd</div>
  <div class="small-column center-content">beschikbare plekken</div>
  <div class="large-column">&nbsp;</div>
</div>

<div class="container header mobile">
  <div>plaats</div>
  <div>datum</div>
</div>

<div *ngFor="let event of events; let i = index">
  <div class="container row web" [class.not-planned]="event.startDateTime < 1">
    <div>{{ event.location?.city }}</div>
    <div *ngIf="event.startDateTime > 0; then thenBlock; else showNotPlanned"></div>
    <ng-template #thenBlock>
      <div>{{ secondsToMilliSeconds(event.startDateTime) | date : 'dd/MM/yyyy' }}</div>
      <div>
        {{ secondsToMilliSeconds(event.startDateTime) | date : 'HH:mm' }}-{{ tillTime(event.startDateTime, event.agenda) | date : 'HH:mm' }}
      </div>
    </ng-template>
    <ng-template #showNotPlanned>
      <div>nog niet ingepland</div>
      <div>&nbsp;</div>
    </ng-template>
    <div *ngIf="event.startDateTime > 0; then showNumberOfAttendees; else hideNumberOfAttendees"></div>
    <ng-template #showNumberOfAttendees>
      <div class="small-column center-content">{{ getAvailableRegistrations(event) }}</div>
    </ng-template>
    <ng-template #hideNumberOfAttendees>
      <div class="small-column center-content">&nbsp;</div>
    </ng-template>
    <div class="large-column">
      <a
        style="width: 10px"
        [href]="getSendToUri(event?.id, event?.location?.city, event?.startDateTime)"
        *ngIf="isRegistrationOpen(event) || isGuestlistOpen(event)"
      >
        Stuur door
        <fa-icon [icon]="faArrowRight"></fa-icon>
      </a>
      <div style="width: 10px" *ngIf="!isRegistrationOpen(event) && !isGuestlistOpen(event)"></div>
      <div *ngIf="!isRegistrationOpen(event) && !isGuestlistOpen(event)">Inschrijving gesloten</div>
      <app-button [routerLink]="getLinkToSubscription(event.id)" [style]="ButtonType.FILLED_PRIMARY" *ngIf="isRegistrationOpen(event)">
        Direct aanmelden
      </app-button>
      <app-button [routerLink]="getLinkToSubscription(event.id)" [style]="ButtonType.FILLED_PRIMARY" *ngIf="isGuestlistOpen(event)">
        Op wachtlijst plaatsen
      </app-button>
      <app-button [style]="ButtonType.FILLED_PRIMARY" *ngIf="event.startDateTime < 1 && 1 === 2">Houd mij op de hoogte</app-button>
      <a (click)="togglePane(i)" [class.hide-link]="event.startDateTime < 1"
        >Details
        <fa-icon [icon]="faAngleDown"></fa-icon>
      </a>
    </div>
  </div>
  <div class="container row mobile" [class.not-planned]="event.startDateTime < 1">
    <div>
      <div>{{ event.location?.city }}</div>
      <div *ngIf="event.startDateTime > 0; then thenShowStartTimeMobile; else thenShowNotPlannedMobile"></div>
      <ng-template #thenShowStartTimeMobile>
        <div>{{ secondsToMilliSeconds(event.startDateTime) | date : 'dd/MM/yyyy' }}</div>
      </ng-template>
      <ng-template #thenShowNotPlannedMobile>
        <div>nog niet ingepland</div>
      </ng-template>
    </div>

    <div>
      <div *ngIf="event.startDateTime > 0; then showNumberOfAttendeesMobile; else hideNumberOfAttendeesMobile"></div>
      <ng-template #showNumberOfAttendeesMobile>
        <div>{{ getAvailableRegistrations(event) }} beschikbare plekken</div></ng-template
      >
      <ng-template #hideNumberOfAttendeesMobile><div>&nbsp;</div></ng-template>
      <div>
        <a (click)="togglePane(i)" *ngIf="event.startDateTime > 0"
          >Details
          <fa-icon [icon]="faAngleDown"></fa-icon>
        </a>
      </div>
    </div>
  </div>

  <div @slideInOut *ngIf="showPane[i]" class="container event-details" [class.not-planned]="event.startDateTime < 1">
    <div>
      <div class="mobile">
        <div class="mobile time">
          <div>tijd</div>
          <div>
            {{ secondsToMilliSeconds(event.startDateTime) | date : 'HH:mm' }}-{{
              tillTime(event.startDateTime, event.agenda) | date : 'HH:mm'
            }}
          </div>
        </div>
        <div>
          <div class="mobile-cta">
            <div>
              <a
                style="width: 10px"
                [href]="getSendToUri(event?.id, event?.location?.city, event?.startDateTime)"
                *ngIf="isRegistrationOpen(event) || isGuestlistOpen(event)"
              >
                Stuur door
                <fa-icon [icon]="faArrowRight"></fa-icon>
              </a>
            </div>
            <div style="width: 10px" *ngIf="!isRegistrationOpen(event) && !isGuestlistOpen(event)"></div>
            <div *ngIf="!isRegistrationOpen(event) && !isGuestlistOpen(event)">Inschrijving gesloten</div>
            <div>
              <app-button
                [routerLink]="getLinkToSubscription(event.id)"
                [style]="ButtonType.FILLED_PRIMARY"
                *ngIf="isRegistrationOpen(event)"
              >
                Direct aanmelden
              </app-button>
              <app-button [routerLink]="getLinkToSubscription(event.id)" [style]="ButtonType.FILLED_PRIMARY" *ngIf="isGuestlistOpen(event)">
                Op wachtlijst plaatsen
              </app-button>
              <app-button [style]="ButtonType.FILLED_PRIMARY" *ngIf="event.startDateTime < 1 && 1 === 2">Houd mij op de hoogte</app-button>
            </div>
          </div>
        </div>
      </div>
      <div>
        <h3>Programma{{ totalTime(event.id, event.startDateTime, event.agenda) }}</h3>
        <ul class="schedule">
          <li *ngFor="let item of event.agenda; let i = index">
            <span>{{ durationTable[event.id][i] | date : 'HH:mm' }}-{{ durationTable[event.id][i + 1] | date : 'HH:mm' }}</span
            >{{ item.description }}
          </li>
        </ul>
        <h3 class="lecturer">Sprekers</h3>
        <ul class="speakers">
          <li>{{ event.lecturer }}</li>
        </ul>
        <span>Als je een training volgt, dan zijn onderstaande zaken allemaal inbegrepen.</span>
        <ul class="course-material">
          <li *ngFor="let facility of event?.facilities">
            <fa-icon [icon]="faCheck"></fa-icon>
            {{ facility }}
          </li>
        </ul>
      </div>
      <div>
        <h3>Adres trainingslocatie</h3>
        <ul class="address">
          <li>{{ event.location?.name }}</li>
          <li>{{ event.location?.address }}</li>
          <li>{{ event.location?.zipCode }}</li>
          <li>{{ event.location?.city }}</li>
          <li>&nbsp;</li>
        </ul>
      </div>
      <div *ngIf="event.location?.contactPerson !== null">
        <ul class="address">
          <h3>Contactpersoon trainingslocatie</h3>
          <li>{{event.location?.contactPerson.name}}</li>
          <li>{{event.location?.contactPerson.email}}</li>
          <li>{{event.location?.contactPerson.phoneNumber}}</li>
        </ul>
      </div>
    </div>
    <div>
      <ul class="address">
        <h3>Opmerkingen</h3>
        <li>{{ event.location?.extraNotes }}</li>
      </ul>
    </div>
  </div>
</div>
